import { type PageProps } from 'gatsby';
import React, { type FC, type ReactNode } from 'react';

import { Footer } from '@/components/navigations/footer';
import { Header } from '@/components/navigations/header';
import t from '@/i18n/current';
import { ClarityScript } from '@/scripts/clarity-script';
import { CookieConsentScript } from '@/scripts/cookie-consent-script';
import { FiizyAnalyticsScript } from '@/scripts/fiizy-analytics-script';
import { GtmDataLayerScript, GtmScript } from '@/scripts/gtm-script';
import { HtmlScript } from '@/scripts/html-script';

interface BaseLayoutProps {
    children: ReactNode;
    location: PageProps['location'];
}

export const BaseLayout: FC<BaseLayoutProps> = ({ location: { pathname }, children }) => {
    const isProduction = process.env['NODE_ENV'] === 'production';

    const isApp = pathname.startsWith(t.formApp.pathname);

    return (
        <>
            {isProduction && t.formApp.type === 'fiizy' && <FiizyAnalyticsScript />}

            <div className="ultra-wide-container">
                <Header />
                <main>{children}</main>
                <Footer />
            </div>

            <HtmlScript />
            {isProduction && <GtmDataLayerScript />}
            {isProduction && isApp && <GtmScript />}
            {isProduction && (
                <CookieConsentScript>
                    {(consent) => (
                        <>
                            {!isApp && <GtmScript />}
                            {consent.statistics === 'granted' && <ClarityScript />}
                        </>
                    )}
                </CookieConsentScript>
            )}
        </>
    );
};
